export enum FormErrorKind {
  REQUIRED = 'required',
  NOT_EMPTY_STRING = 'notEmptyString',
  NOT_EMPTY_ARRAY = 'notEmptyArray',
  PATTERN = 'pattern',
  POSITIVE = 'positive',
  REGISTER_NUMBER = 'registerNumber',
  DATE_IN_PAST = 'dateInThePast',
  DATE_IN_FUTURE = 'dateInTheFuture',
  UNVALID_RANGE_START = 'unvalidDateRangeStart',
  UNVALID_RANGE_END = 'unvalidDateRangeEnd',
}
